/* The Diamond Empire: loader. The real code is hosted in Shopify Files (de-motion-live.js), so it can be updated without publishing a new theme. */
(function () {
  var s = document.createElement('script');
  s.src = 'https://cdn.shopify.com/s/files/1/0583/7832/2073/files/de-motion-live.js?v=' + Math.floor(Date.now() / 600000);
  s.defer = true;
  document.head.appendChild(s);
})();
